import type { SoccerPreviewData } from './resolvePreviewData';

const CUSTOM_ASSET_PLACEHOLDER_REGEX = /{([\w-]+):([\w_]+)}/g;
const SPORT_RADAR_COMPETITOR_ID_PREFIX = 'sr:competitor:';

const SUPPORTED_CUSTOM_ASSET_DATA_POINT_NAMES = new Set([
  'TEAM_HOME_COMPETITOR_ID',
  'TEAM_AWAY_COMPETITOR_ID',
  'MOMENT_GOAL_TEAM_COMPETITOR_ID',
  'POST_WINNER_TEAM_COMPETITOR_ID',
]);

export const resolveCustomAssetUrl = (
  content: string | undefined,
  soccerPreviewData?: SoccerPreviewData,
): string | undefined => {
  if (!content || !soccerPreviewData) {
    return undefined;
  }

  const matches = Array.from(content.matchAll(CUSTOM_ASSET_PLACEHOLDER_REGEX));

  if (matches.length === 0) {
    return undefined;
  }

  let resolvedContent = content;

  for (const match of matches) {
    const placeholder = match[0];
    const dataPointName = match[2];

    if (!SUPPORTED_CUSTOM_ASSET_DATA_POINT_NAMES.has(dataPointName)) {
      return undefined;
    }

    const value = soccerPreviewData[dataPointName];

    if (typeof value !== 'string' || value.length === 0) {
      return undefined;
    }

    const resolvedCompetitorId = value.startsWith(SPORT_RADAR_COMPETITOR_ID_PREFIX)
      ? value.slice(SPORT_RADAR_COMPETITOR_ID_PREFIX.length)
      : value;

    resolvedContent = resolvedContent.split(placeholder).join(resolvedCompetitorId);
  }

  return resolvedContent;
};
